module.exports = __webpack_public_path__ + "static/img/arthroscopy-02.4faae6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-02.jpg
// module id = +pN6
// module chunks = 52